import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "blockSize", "borderRadius", "children", "isLoading", "inlineSize", "variant"];
import styled from 'styled-components';
import { LayoutBox } from '../Layout/LayoutBox';
import { BreezeSkeleton } from './BreezeSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const BreezeBrandedSkeleton = styled(BreezeSkeleton).withConfig({
  displayName: "Skeleton__BreezeBrandedSkeleton",
  componentId: "w2lld5-0"
})(["display:flex;line-height:1;"]);
const gradientColor = variant => `--bg-color: ${variant === 'light' ? 'var(--bg-light)' : 'var(--bg-base)'}`;
const Loading = styled(LayoutBox).withConfig({
  displayName: "Skeleton__Loading",
  componentId: "w2lld5-1"
})(["--bg-base:0,0%,100%;--bg-light:0,0%,80%;", ";--highlight-gradient:linear-gradient( -45deg,hsla(var(--bg-color),0%) 35%,hsla(var(--bg-color),53%) 50%,hsla(var(--bg-color),0%) 65% );display:block;overflow:hidden;position:relative;z-index:1;@keyframes loading-skeleton{100%{transform:translateX(5%);}}&::after{animation:loading-skeleton 3s ease-out infinite;background:var(--highlight-gradient) no-repeat;block-size:200%;content:'';display:var(--animation-display,block);inline-size:400%;inset:0;position:absolute;transform:translateX(-100%);}@media (prefers-reduced-motion){--animation-display:none;}"], ({
  variant
}) => gradientColor(variant));
export const Skeleton = _ref => {
  let {
      as,
      blockSize,
      borderRadius = 'border-radius',
      children,
      isLoading = true,
      inlineSize,
      variant = 'default'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const background = variant === 'light' ? 'background-color-light' : 'background-color';
  const LoadingSkeleton = () => {
    if (variant === 'breeze') {
      return /*#__PURE__*/_jsx(BreezeBrandedSkeleton, {
        as: as,
        blockSize: blockSize,
        borderRadius: borderRadius,
        inlineSize: inlineSize
      });
    }
    return /*#__PURE__*/_jsx(Loading, Object.assign({}, rest, {
      as: as,
      background: background,
      blockSize: blockSize,
      borderRadius: borderRadius,
      inlineSize: inlineSize,
      lineHeight: 1,
      variant: variant
    }));
  };
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingSkeleton, {});
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};